/**
 * Extrai a sigla da unidade de medida a partir da tradução completa
 * Exemplo: "Un (Unidade)" -> "Un"
 * @param {string} fullUnitText - Texto completo da unidade de medida
 * @returns {string} Sigla da unidade
 */
export const getUnitAbbreviation = (fullUnitText) => {
    if (!fullUnitText) return '';
    return fullUnitText.split('(')[0].trim();
};

/**
 * Retorna a sigla da unidade de medida baseado no código e função de tradução
 * @param {string} unitCode - Código da unidade (UNIT, GRAM, KILOGRAM, LITER)
 * @param {Function} t - Função de tradução do i18next
 * @returns {string} Sigla da unidade
 */
export const getUnitLabel = (unitCode, t) => {
    if (!unitCode || !t) return '';
    const fullText = t(`unit_measure.${unitCode.toLowerCase()}`);
    return getUnitAbbreviation(fullText);
};

/**
 * Retorna as opções de unidade de medida para selects
 * @param {Function} t - Função de tradução do i18next
 * @returns {Array} Array de objetos com value e label
 */
export const getUnitMeasureOptions = (t) => {
    const units = ['UNIT', 'GRAM', 'KILOGRAM', 'LITER'];
    return units.map(unit => ({
        value: unit,
        label: getUnitLabel(unit, t)
    }));
};

/**
 * Verifica se a unidade de medida deve usar casas decimais
 * @param {string} unitCode - Código da unidade (UNIT, GRAM, KILOGRAM, LITER)
 * @returns {boolean} true se deve usar decimais, false caso contrário
 */
export const shouldUseDecimals = (unitCode) => {
    if (!unitCode) return false;
    const code = unitCode.toUpperCase();
    // UNIT não usa decimais, as demais (GRAM, KILOGRAM, LITER) usam
    return code !== 'UNIT';
};

/**
 * Formata a quantidade baseado na unidade de medida
 * @param {number} value - Valor a ser formatado
 * @param {string} unitCode - Código da unidade (UNIT, GRAM, KILOGRAM, LITER)
 * @returns {string} Valor formatado
 */
export const formatQuantityByUnit = (value, unitCode) => {
    if (value == null) return '';
    
    const numericValue = Number(value);
    
    if (shouldUseDecimals(unitCode)) {
        // Formata com 2 casas decimais no padrão brasileiro
        return numericValue.toLocaleString('pt-BR', { 
            minimumFractionDigits: 2, 
            maximumFractionDigits: 2 
        });
    } else {
        // Retorna número inteiro
        return Math.floor(numericValue).toString();
    }
};
